import { Modal, Checkbox, Button, Input } from "antd";
import { useEffect, useState } from "react";
import { useAtualizarReservaStatus } from "../hooks/useAtualizarReservaStatus";
import { useError } from "../../../uteis/mensagens/useError";
import { useSuccess } from "../../../uteis/mensagens/useSuccess";
import { useNavigate } from "react-router-dom";

import { enviarEmail } from "../../../components/Globais";

interface ModalCancelarProps {
  isModalOpen: boolean;
  handleFechar: () => void;
  reservaId: null | number;
  nomeEmpreend: null | string;
  checkIn: null | string;
  checkOut: null | string;
  proprietarioId: null | number;
}

export default function ModalCancelar({
  isModalOpen,
  handleFechar,
  reservaId,
  nomeEmpreend,
  checkIn,
  checkOut,
  proprietarioId,
}: ModalCancelarProps) {
  const [motivoCancelamento, setMotivoCancelamento] = useState("");
  const [reservaStatus, setReservaStatus] = useState<string>("");
  const [email, setEmail] = useState(true);

  // Exibe a Mensagem de  Erro
  const { showError, contextHolder: errorContextHolder } = useError();

  // Exibe a Mensagem de  Erro
  const { showSuccess, contextHolder: successContextHolder } = useSuccess();

  // Estado para controlar se o sucesso já foi exibido
  const [successDisplayed, setSuccessDisplayed] = useState(false);

  // Estado para controlar se o erro já foi exibido
  const [errorDisplayed, setErrorDisplayed] = useState(false);

  // Funçao navigate que é utilizada para o reload da página
  const navigate = useNavigate();

  // Função utilizada para atualizar o status da reserva
  const {
    isLoading,
    reservaStatusAtualizado,
    success: successStatus,
    error: errorStatus,
  } = useAtualizarReservaStatus(reservaId, reservaStatus);

  const handleConfirmarCancelamento = async () => {
    // Verificar se o motivo de cancelamento foi preenchido
    if (!motivoCancelamento.trim()) {
      alert("Por favor, insira um motivo para o cancelamento.");
      return;
    }

    try {
      let resposta;

      // Enviar email caso a opção esteja marcada
      if (email) {
        resposta = await enviarEmail({
          userId: proprietarioId,
          tipoEmail: 20,
          subjectEmail: "Cancelamento de Reserva",
          bodyEmail: motivoCancelamento,
          info: {
            emprendimento: nomeEmpreend,
            checkIn: checkIn,
            checkOut: checkOut,
          },
        });
      }

      // Atualizar o status da reserva para "CANCELADA" se o email for enviado com sucesso
      if (resposta) {
        setReservaStatus("CANCELADA");
      } else {
        console.warn("O envio do email falhou, mas a reserva foi cancelada.");
        setReservaStatus("CANCELADA");
      }
    } catch (error) {
      // Tratamento de erros
      console.error("Erro ao tentar cancelar a reserva:", error);
      alert("Ocorreu um erro ao tentar cancelar a reserva. Tente novamente.");
    }
  };

  // Combina os estados de sucesso e erro para simplificar a lógica
  const successMessage = successStatus;
  const errorMessage = errorStatus;

  // useEffect para lidar com o sucesso
  useEffect(() => {
    if (reservaStatusAtualizado && successMessage && !successDisplayed) {
      showSuccess(successMessage);
      setSuccessDisplayed(true);
      setTimeout(() => {
        navigate(0); // Simula um refresh completo
      }, 2000);
    }
  }, [
    reservaStatusAtualizado,
    successMessage,
    showSuccess,
    successDisplayed,
    navigate,
  ]);

  // useEffect para lidar com o erro
  useEffect(() => {
    if (!reservaStatusAtualizado && errorMessage && !errorDisplayed) {
      showError(errorMessage);
      setErrorDisplayed(true);
      setTimeout(() => {
        navigate(0); // Simula um refresh completo
      }, 1000);
    }
  }, [
    reservaStatusAtualizado,
    errorMessage,
    showError,
    errorDisplayed,
    navigate,
  ]);

  return (
    <Modal
      open={isModalOpen}
      onCancel={handleFechar}
      footer={null}
      title="Cancelar Reserva"
      confirmLoading={isLoading}
    >
      <>{errorContextHolder}</>
      <>{successContextHolder}</>
      <p>Tem certeza que deseja cancelar esta reserva?</p>
      <Input.TextArea
        placeholder="Informe o motivo do cancelamento"
        value={motivoCancelamento}
        onChange={(e) => setMotivoCancelamento(e.target.value)}
        rows={4}
        style={{ marginBottom: 16 }}
      />
      <Checkbox checked={email} onChange={(e) => setEmail(e.target.checked)}>
        Enviar Email
      </Checkbox>
      <div style={{ marginTop: 16, textAlign: "right" }}>
        <Button onClick={handleFechar} style={{ marginRight: 8 }}>
          Cancelar
        </Button>
        <Button
          type="primary"
          onClick={handleConfirmarCancelamento}
          disabled={!motivoCancelamento.trim()}
        >
          Confirmar
        </Button>
      </div>
    </Modal>
  );
}
